import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { PageLayout } from 'containers/layout';
import TableNumberForm from 'containers/tab/TableNumberForm';
import TableWarning from 'containers/tab/TableWarning';
import CheckSelect from 'containers/tab/CheckSelect';

import { IonButton, useIonViewDidEnter } from '@ionic/react';
import PayActions from 'redux/PayRedux';
import AppActions, { AppSelectors } from 'redux/AppRedux';
import { AuthSelectors } from 'redux/AuthRedux';
import SplitWarningModal from 'containers/tab/SplitWarningModal';
import PaymentErrorModal from 'containers/payment/PaymentErrorModal';
import api_v2 from 'services/api_v2';

function TableNumberPage() {
  const dispatch = useDispatch();
  const params = useParams();
  const token = useSelector(AuthSelectors.selectToken);

  const [warning, setWarning] = useState(false);
  const [checks, setChecks] = useState([]);
  const [step, setStep] = useState(0);
  const [selectedId, setSelectedId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [showPaymentErrorAlert, setShowPaymentErrorAlert] = useState(false);

  const venueDetail = useSelector(
    AppSelectors.selectVenueDetailById(params.locationId)
  );
  const history = useHistory();

  useIonViewDidEnter(() => {
    setStep(0);
    setSelectedId(null);
    setSaving(false);
  });

  const handleCheckSubmit = async (check) => {
    try {
      if (check.users && check.users.length > 0 && venueDetail.isFullPay) {
        setWarning(true);
        return;
      }
      const api = api_v2(token);
      setSaving(true);
      const ticket = await api.join(check._id, params.locationId);

      dispatch(PayActions.setIsTable(true));
      dispatch(AppActions.setVenue(params.locationId));
      dispatch(PayActions.setTicket(ticket));
      setSaving(false);
      history.replace(`/locations/${params.locationId}/tab`);
    } catch (e) {
      dispatch(
        AppActions.setToast(
          e.message ||
            'There are no items added to your check yet. Please order with your server.',
          'danger'
        )
      );
      setSaving(false);
    }
  };

  const handleTableNumberSubmit = (ticket) => {
    handleCheckSubmit(ticket);
  };

  const handleSelectedSubmit = () => {
    const selected = checks.find((c) => c._id === selectedId);

    if (selected) {
      handleCheckSubmit(selected);
    }
  };

  return (
    <PageLayout
      title={step === 2 ? 'Select your items' : 'Table'}
      back="/locations"
      footer={
        step === 2 && (
          <IonButton
            expand="full"
            fill="solid"
            color="tertiary"
            onClick={handleSelectedSubmit}
            disabled={!selectedId || saving}
          >
            {saving ? 'Loading...' : 'Select'}
          </IonButton>
        )
      }
    >
      {step === 0 && (
        <TableNumberForm
          venueId={params.locationId}
          onSubmit={handleTableNumberSubmit}
          setShowPaymentErrorAlert={setShowPaymentErrorAlert}
        />
      )}

      {step === 1 && <TableWarning onClose={() => setStep(2)} />}

      {step === 2 && (
        <CheckSelect
          checks={checks}
          onSelect={saving ? () => {} : setSelectedId}
          selectedId={selectedId}
        />
      )}

      <SplitWarningModal open={warning} onClose={() => setWarning(false)} />

      <PaymentErrorModal
        isOpen={showPaymentErrorAlert}
        setShowAlert={setShowPaymentErrorAlert}
      />
    </PageLayout>
  );
}

export default TableNumberPage;
